export default __webpack_public_path__ + "static/media/check-mark-green.9edf1981.svg";